import { cooperationModeEnum } from "@/service/supplier-meta/enums/cooperationModeEnum";
export function getCooperationModeTips(
  cooperationMode: cooperationModeEnum
): string {
  let tips = "";
  switch (cooperationMode) {
    case cooperationModeEnum.常规采销:
      tips =
        "（注释：棒谷采购，供应商发货到棒谷仓库，棒谷收到货后跟供应商结算，棒谷销售，棒谷发货给商城用户）";
      break;
    case cooperationModeEnum.一件代发:
      tips =
        "（注释：棒谷无库存销售，商城用户下单，供应商发货商城用户，用户收到货后棒谷跟供应商结算）";
      break;
    case cooperationModeEnum.代销:
      tips =
        "（注释：供应商发货到棒谷仓库，棒谷销售，商城用户下单，供应商发货商城用户，根据销售数量跟供应商结算）";
      break;
  }
  return tips;
}
